import { WorkflowsRootState } from '../ducks.types';
import { getEdges } from './edges';
import { getNodes } from './nodes';

export const getWorkflowState = (state: WorkflowsRootState) => state.workflow || {};
export const getWorkflow = (state: WorkflowsRootState) => state.workflow?.workflow || {};
export const getWorkflowHasUnsavedChanges = (state: WorkflowsRootState) =>
  state.workflow?.hasUnsavedChanges;
export const getIsWorkflowSaving = (state: WorkflowsRootState) => state.workflow?.saving;

export const getCompleteWorkflow = (state: WorkflowsRootState) => ({
  ...getWorkflow(state),
  edges: getEdges(state),
  nodes: getNodes(state),
});
export const getJourneyCurrentConversion = (state: WorkflowsRootState) =>
  state.workflow?.workflow?.goals?.find((x) => x.isActive);
export const getJourneyCurrentConversionEvent = (state: WorkflowsRootState) =>
  state.workflow?.workflow?.goals?.find?.((x) => x.isActive)?.conversions?.[0];
export const getJourneyCurrentConversionEventName = (state: WorkflowsRootState) =>
  state.workflow?.workflow?.goals?.find?.((x) => x.isActive)?.conversions?.[0]?.eventName;

export const getWorkflowView = (state: WorkflowsRootState) => state.workflow?.workflowView;
export const getJourneyVisitorCounts = (state: WorkflowsRootState) => {
  const { visitorsEntered, visitorsFinished, visitorsExitedByRules } =
    state.workflow?.workflow || {};
  return { visitorsEntered, visitorsFinished, visitorsExitedByRules };
};
